<template>
  <div class="credit-list flex-column height-all" :class="`${createRenderType}-credit-list`">
    <div class="flex-column-center info-box">
      <div class="subscribe" v-if="createRenderType == 'pc'">
        {{  $t("common.nav_credits") }}
        <div class="countdown" v-if="userDataStore.countdown > 0">
          <div class="time"><img src="@/assets/img/home/icon-clock.png" alt=""><span>{{ $t('credit.expires_in') + ': ' + formatCountdown(userDataStore.countdown) }}</span></div>
          <div class="tip">
            <div class="big"><span>{{userDataStore.userInfo?.discount?.discount_percent ?? ''}}%</span> {{ $t("credit.off") }}!!!</div>
            <div>{{$t('credit.once_expired')}}</div>
          </div>
        </div>
      </div>
      <div class="countdown" v-if="createRenderType !== 'pc' && userDataStore.countdown > 0">
        <div class="time"><img src="@/assets/img/home/icon-clock.png" alt=""><span>{{ $t('credit.expires_in') + ': ' + formatCountdown(userDataStore.countdown) }}</span></div>
        <div class="tip">
          <div class="big"><span>{{userDataStore.userInfo?.discount?.discount_percent ?? ''}}%</span> {{ $t("credit.off") }}!!!</div>
          <div>{{$t('credit.once_expired')}}</div>
        </div>
      </div>
      <div class="info flex">
        <div class="flex-center top" v-if="isVip">
          <img class="member" src="@/assets/img/credit/member.png" alt="" />
          <div class="valid common">
            {{ `${$t("credit.subscriptionRenewalDate")}: ${tools.formatDate(vipEnd * 1000, "MM/DD/YYYY")}` }}
          </div>
        </div>
        <div :class="createRenderType == 'mobile' && isVip ? ['flex-column', 'show-credit'] : 'flex-row-center'">
          <div class="flex-center">
            <div class="flex common">
              {{ $t("credit.credits") }}:
              <span class="pointer remaining" @click="handleView">{{ userDataStore?.credits || 0 }}</span>
              <img class="next pointer" src="@/assets/img/content/next.png" alt="" @click="handleView" />
            </div>
            <div v-if="isVip" class="add-credits pointer" @click="showCredits">
              {{ $t("credit.addCredits") }}
            </div>
          </div>
          <div
            v-if="ModuleOpenStateControl.create.release"
            class="pointer common flex-center"
            :class="isVip ? ['time', createRenderType == 'mobile' ? '' : 'release'] : 'release'"
          >
            {{ $t("credit.releaseCount") }}：<span class="pointer remaining" @click="handleViewReleaseRecord"
              >{{ showData.release_amount_left || 0 }}/ {{ showData.release_amount_by_plan || 0 }}</span
            >
          </div>
        </div>
        <!-- <div class="flex-row-center remaining common"></div> -->
      </div>
    </div>
    <div class="main flex-column flex1">
      <SubscribePlan
        ref="subscribePlanRef"
        @changeSubEnable="changeSubEnable"
        @changeInEffect="changeInEffect"
        @handleCheckout="(item, channel) => handleCheckout(item, channel, 'sub')"
        @getProductList="getProductList"
        :isloading="isloading"
        :productList="props.productList"
      ></SubscribePlan>
      <div class="summary flex-center">
        <div class="pointer" @click="handleGoPolicy">
          {{ $t("mine.PrivacyPolicy") }}
        </div>
        <div class="line">|</div>
        <div class="pointer" @click="handleGoTerms">
          {{ $t("mine.TermsofService") }}
        </div>
        <div v-if="globleConfig.appname == 'Mureka'">
          <div class="line">|</div>
          <div class="pointer" @click="handleGoOcean">
            {{ 'Subscription Agreement' }}
          </div>
        </div>
        <div v-if="globleConfig.appname == 'MurekaCn'" class="pointer"  @click="handleGoPayment"> <div class="line">|</div>Mureka付费服务协议</div> 
      </div>
      <div class="support flex-center">{{ $t("mine.support", { param1: "@" }) }}</div>
      <div class="flex-center" v-if="!(isCancelStatus && subType=='paypal') && subEnable && inEffect && globleConfig.appname == 'Mureka'">
        <div class="view pointer" @click="handleManage">
          {{ isCancelStatus ? $t("credit.reactivate") :$t("credit.manage") }}
        </div>
      </div>
      <div class="flex-column-center app-subscribe" v-if="!subEnable && inEffect">
        <div>{{ $t("credit.subscriptions_note") }}</div>
        <div>{{ $t("credit.cancel_subscription_within_app") }}</div>
      </div>
    </div>
  </div>
  <!-- 买积分弹窗 -->
  <CreditsDialog
    v-if="creditsDialogVisible"
    v-model:visible="creditsDialogVisible"
    @handleCreditCheckout="(item, channel) => handleCheckout(item, channel,'credit')"
  ></CreditsDialog>
  <CancelDialog
    v-if="cancelDialogVisible"
    v-model:visible="cancelDialogVisible"
    :manageUrl="manageUrl"
    @handleCancelSubscribe="reasonDialogVisible = true"
  >
  </CancelDialog>
  <ReasonDialog v-if="reasonDialogVisible" v-model:visible="reasonDialogVisible" v-model:cancelReasonList="cancelReasonList" :manageUrl="manageUrl" @confirmCancel="handleConfirmCancel"> </ReasonDialog>
  <ConfirmCancelDialog v-if="confirmCancelVisible" v-model:visible="confirmCancelVisible" :vipEnd="vipEnd" :list="cancelReasonList" @confirmCancelSuccess="confirmCancelSuccess"></ConfirmCancelDialog>
</template>

<script setup>
import { ref, defineProps, defineEmits, defineExpose, watch, onMounted } from "vue"
import { storeToRefs } from "pinia"
import { useRoute, useRouter } from "vue-router"
import globleConfig, { ModuleOpenStateControl } from "@/config/config.js"
import apiUser from "@/api/api/apiUser.js"
import { manageSubscription } from "@/api/api/apiCredit.js"
import tools from "@/utils/tools.js"
import useUserDataStore from "@/store/userDataStore"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import SubscribePlan from "./subscribePlan.vue"
import CreditsDialog from "./creditsDialog.vue"
import CancelDialog from "./cancelDialog.vue"
import ReasonDialog from "./reasonDialog.vue"
import ConfirmCancelDialog from "./confirmCancelDialog.vue"

import store from "@/store/index.js"

const userDataStore = useUserDataStore()
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const { isCancelStatus } = storeToRefs(userDataStore)
const emits = defineEmits(["handleCreditCheckout", "handleView", "handleViewReleaseRecord",'getProductList'])
const Router = useRouter();
const route = useRoute()
const props = defineProps({
  // currentCredits: {
  //   type: Number,
  //   default: 0,
  // },
  showData: {
    type: Object,
    default: () => ({}),
  },
  isloading: {
    type: Boolean,
    default: false,
  },
  productList:{
    type: Array,
    default: () => [],
  },
  inEffectInfo:{
    type: Object,
    default: () => {}
  }
})

const isVip = ref("")
const inEffect = ref(false)
const vipEnd = ref("")
const subEnable = ref(false)
const creditsDialogVisible = ref(false)
const cancelDialogVisible = ref(false)
const reasonDialogVisible = ref(false)
const confirmCancelVisible = ref(false)
const manageUrl = ref("")
const cancelReasonList = ref([])
const subType = ref("")

watch(
  [inEffect, subEnable],
  ([newInEffect, newSub]) => {
    if (newInEffect && newSub) {
      getManageSubscription()
    }
  },
  { deep: true }
)

watch(
  () => userDataStore.isLogin,
  (val) => {
    if (val) {
      getInfo()
    } else {
      isVip.value = ""
      subEnable.value = false
      subType.value = ""
    }
  }
)

const getProductList = ()=>{
  emits("getProductList");
}

const formatCountdown = (seconds) => {
  const totalMinutes = Math.floor(seconds / 60);
  const minutes = totalMinutes % 60;
  const secondsLeft = seconds % 60;

  // 格式化为 "mm min ss s"
  const formattedMinutes = `${minutes.toString().padStart(2, "0")}min`;
  const formattedSeconds = `${secondsLeft.toString().padStart(2, "0")}s`;

  // 如果分钟为0且秒数>0，则只显示秒（例如：05s）
  if (totalMinutes === 0) {
    return `${secondsLeft}s`;
  }

  return [formattedMinutes, formattedSeconds].join(" ");
};

const showCredits = () => {
  creditsDialogVisible.value = true
}

const handleGoTerms = () => {
  window.open(globleConfig.appname == "MurekaCn" ? import.meta.env.VITE_API_URL + "/static/terms.pdf" : "/terms", "_blank");
}

const handleGoPolicy = () => {
  window.open(globleConfig.appname == "MurekaCn" ? import.meta.env.VITE_API_URL + "/static/privacy.pdf" : "/privacy", "_blank");
}

const handleGoOcean = () =>{
  window.open(window.location.origin + "/oceanpay-doc", "_blank")
}

const handleGoPayment = () =>{
  window.open(import.meta.env.VITE_API_URL + "/static/payment.pdf", "_blank")
}

const handleCheckout = (item, channel, type) => {
  if (item.in_effect == 1) {
    return
  }
  emits("handleCreditCheckout", item, channel, type)
}

const handleView = () => {
  emits("handleView")
}

const handleViewReleaseRecord = () => {
  emits("handleViewReleaseRecord")
}

const getInfo = () => {
  apiUser.userGetInfo().then((res) => {
    if (res.code == 200) {
      isVip.value = !!res?.data?.user?.is_vip
      vipEnd.value = res?.data?.user?.vip_end
    }
  })
}

const handleManage = () => {
  if (isCancelStatus.value) {
    window.open(manageUrl.value, "_blank");
  } else {
    cancelDialogVisible.value = true
  }
}

const changeSubEnable = () => {
  subEnable.value = true
}

const changeInEffect = (data) => {
  inEffect.value = true
  subType.value = data
}

const getManageSubscription = () => {
  if (props.inEffectInfo.type == "paypal") {
    manageUrl.value = globleConfig.paypalConsoleUrl;
  } else {
    manageSubscription({
      channel: "stripe",
    }).then((res) => {
      if (res.code == 200) {
        manageUrl.value = res?.data?.url;
      }
    });
  }
};

const handleConfirmCancel = () => {
  confirmCancelVisible.value = true
}

const confirmCancelSuccess = () => {
  userDataStore.changeCancelState(false)
}

onMounted(() => {
  userDataStore.checkCancelState()
  getInfo()
  if (route.query?.show_credits || route.query?.buy_type=='credits') {
    showCredits()
  }
})

defineExpose({
  getInfo, // 暴露这个方法
});
</script>

<style lang="scss" scoped>
.credit-list {
  color: #fff;
  .avatar {
    display: block;
    width: 68px;
    height: 68px;
    border-radius: 50%;
  }
  .countdown {
    color: #fff;
    position: relative;
    background: linear-gradient(91deg, #4fdeff -40%, #d9f8ff 52%, #e675ff 132%);
    height: 52px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 8px 6px 6px;
    gap: 6px;
    border-radius: 10px;
    .time {
      display: flex;
      align-items: center;
      background: #000000;
      padding: 0 8px;
      height: 40px;
      gap: 4px;
      border-radius: 6px;
      img {
        width: 16px;
        height: 16px;
      }
      span {
        background: linear-gradient(108deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        font-size: 14px;
        font-weight: 900;
        line-height: 18px;
      }
    }
    .tip {
      font-size: 10px;
      font-weight: 900;
      line-height: 14px;
      color: #000000;
      display: flex;
      flex-direction: column;
      // gap: 2px;
      .big {
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }
      span {
        color: #ff5f74;
        display: inline-block;
      }
    }
  }
  .info {
    margin-top: 16px;
    .next {
      width: 16px;
      height: 16px;
      margin-left: 2px;
    }
    .name {
      font-size: 20px;
      font-weight: bold;
      line-height: 24px;
    }
    .member {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .common {
      font-size: 14px;
      line-height: 14px;
    }
    .release {
      margin-left: 36px;
    }
    .add-credits {
      background: linear-gradient(108deg, rgba(79, 222, 255, 0.4) 0%, rgba(230, 117, 255, 0.4) 99%);
      padding: 4px 16px;
      font-size: 12px;
      font-weight: 500;
      line-height: 24px;
      border-radius: 52px;
      margin: 0 0 0 12px;
    }
    .remaining {
      text-decoration: underline;
    }
  }
  .view {
    padding: 6px 12px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(255, 255, 255, 0.6);
    height: max-content;
    align-self: flex-end;
  }
  .summary {
    text-align: center;
    margin: 24px 0 12px 0;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    .pointer {
      color: #94adff;
      display: inline-block;
    }
    .line {
      color: rgba(255, 255, 255, 0.3);
      margin: 0 8px;
      display: inline-block;
    }
  }
  .app-subscribe {
    font-size: 12px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
  }
  .support {
    font-size: 12px;
    color: #fff;
    margin-bottom: 12px;
  }
}

.pc-credit-list {
  position: relative;
  padding: 0x 34px;
  .info-box {
    .subscribe {
      font-size: 36px;
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 12px;
      
    }
    
    .valid {
      margin-right: 36px;
    }
  }

  .main {
    margin-top: 20px;

    .content {
      border-radius: 0 20px 20px 20px;

      .list {
        padding-top: 40px;
        // width: max-content;
      }
    }
  }

  .summary {
    // margin-top: 40px;
    font-size: 12px;
    line-height: 20px;
    opacity: 0.6;
    text-align: center;
    span {
      color: rgba(255, 255, 255, 0.45);
      border-bottom: 1px solid rgba(255, 255, 255, 0.6);
      &:hover {
        color: #94adff;
        border-bottom: 1px solid #94adff;
      }
    }
  }
}

.mobile-credit-list {
  .header-back {
    padding: 20px 16px;
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 18px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
    }
    .manage {
      padding: 6px 12px;
      color: rgba(255, 255, 255, 0.6);
      background: rgba(255, 255, 255, 0.2);
      font-size: 12px;
      line-height: 16px;
      border-radius: 16px;
    }
  }
  .wrapper {
    flex: 1;
  }

  .info-box {
    align-items: center;
    .info {
      flex-direction: column;
      margin-top: 20px;
      .member {
        width: 16px;
        height: 16px;
      }
      .release {
        margin-left: 24px;
      }
      .show-credit {
        margin-top: 10px;
      }
      .time {
        margin-top: 10px;
      }
      .common {
        font-size: 12px;
      }
      .add-credits {
        padding: 0 11px;
        font-size: 10px;
        font-weight: 500;
        margin-right: 0;
        // line-height: 24px;
      }
    }
    .subscribe {
      font-size: 28px;
      font-weight: bold;
    }
  }
  .main {
    margin-top: 20px;
  }

  .summary {
    margin: 19px auto;
    font-size: 12px;
    line-height: 20px;
    opacity: 0.6;
    text-align: center;
    span {
      color: rgba(255, 255, 255, 0.45);
      border-bottom: 1px solid rgba(255, 255, 255, 0.6);
      &:hover {
        color: #94adff;
        border-bottom: 1px solid #94adff;
      }
    }
  }
  .view {
    margin: 0 0 30px;
  }
  .app-subscribe {
    padding: 0 24px 18px;
    text-align: center;
  }
}
</style>
